import i18n from '@/config/i18n';

// 지역명 매핑 (한글 → 번역 키)
export const REGION_TO_I18N_KEY: Record<string, string> = {
    동대문: 'building.dongdaemun',
    남대문: 'building.namdaemun',
    부산: 'building.busan',
};

// 건물명 매핑 (한글 → 번역 키)
export const BUILDING_TO_I18N_KEY: Record<string, string> = {
    디오트: 'building.diot',
    청평화: 'building.cph',
    누죤: 'building.nuzzon',
    APM: 'building.apm',
    남평화: 'building.nph',
    테크노: 'building.techno',
    제일평화: 'building.jeilpeace',
    동평화: 'building.dph',
    '퀸즈스퀘어(광희)': 'building.queensSquare',
    스튜디오W: 'building.studioW',
    'DWP (동원프라자)': 'building.dwp',
    벨포스트: 'building.bellPost',
    'APM 럭스': 'building.apmLux',
    디자이너클럽: 'building.designerClub',
    'DDP(유어스)': 'building.ddpFashionMall',
    팀204: 'building.team204',
    '혜양 엘리시움': 'building.hyeyangElysium',
    'APM PLACE': 'building.apmPlace',
    맥스타일: 'building.maxStyle',
    '신발상가 A동': 'building.shoeMallA',
    '신발상가 B동': 'building.shoeMallB',
    '신발상가 C동': 'building.shoeMallC',
    '신발상가 D동': 'building.shoeMallD',
    '신평화 A동': 'building.sinpeaceA',
    '신평화 B동': 'building.sinpeaceB',
    '신평화 C동': 'building.sinpeaceC',
    평화시장: 'building.peaceMarket',
    '시즌상가 (JABA11)': 'building.seasonMall',
    아트프라자: 'building.artPlaza',
    'SANG SANG(상상)': 'building.sangSang',
    동문상가: 'building.dongmunMall',
    청계상가: 'building.cheonggyeMall',
    서평화: 'building.seopeace',
    종합시장: 'building.generalMarket',
    통일상가: 'building.tongilMall',
    동일상가: 'building.dongilMall',
    'NYUNYU (골든타운)': 'building.nyunyu',
    포키아동복: 'building.pokiKids',
    원아동복: 'building.wonKids',
    부르뎅: 'building.bourdeng',
    마마아동복: 'building.mamaKids',
    크레용아동복: 'building.crayonKids',
    코코상가: 'building.cocoMall',
    '씨티아이 아동복': 'building.ctiKids',
    새로나아동복: 'building.saeronaKids',
    키즈빌리지: 'building.kidsVillage',
    탑랜드아동복: 'building.toplandKids',
    페인트타운: 'building.paintTown',
    삼익패션타운: 'building.samikFashion',
    우주상가: 'building.woojuMall',
    '대도 아케이드': 'building.daedoArcade',
    렝땅: 'building.lengddang',
    '원 도깨비': 'building.wonDokkaebi',
    '도깨비 C동': 'building.dokkaebiC',
    '도깨비 D동': 'building.dokkaebiD',
    '도깨비 E동': 'building.dokkaebiE',
    유성상가: 'building.yuseongMall',
    쥬얼파크: 'building.jewelPark',
    연세악세사리: 'building.yonseiAccessory',
    삼호악세사리: 'building.samhoAccessory',
    마노악세사리: 'building.manoAccessory',
    장안악세사리: 'building.janganAccessory',
    대도쥬얼리: 'building.daedoJewelry',
    자유핸드백: 'building.jayuHandbag',
    대도마케트: 'building.daedoMarket',
    남도상가: 'building.namdoMall',
    남정상가: 'building.namjeongMall',
    영창상가: 'building.yeongchangMall',
    '대도종합상가 D동': 'building.daedoGeneralD',
    '르네시티(르네관)': 'building.renecite1',
    '르네시떼(시떼관)': 'building.renecite2',
    남문시장: 'building.nammunMarket',
    자유시장: 'building.jayuMarket',
    진시장: 'building.jinMarket',
    '국제시장 3공구 A동': 'building.intlMarket3A',
    '국제시장 3공구 B동': 'building.intlMarket3B',
    '국제시장 1공구 B동': 'building.intlMarket1B',
    '국제시장 2공구 B동': 'building.intlMarket2B',
    '국제시장 2공구': 'building.intlMarket2',
    '국제시장 6공구': 'building.intlMarket6',
};

// 번역된 지역명을 반환하는 함수
export const getRegionName = (regionKey: string): string => {
    const i18nKey = REGION_TO_I18N_KEY[regionKey];
    return i18nKey ? i18n.t(i18nKey) : regionKey;
};

// 번역된 건물명을 반환하는 함수 (지역 정보를 함께 받아 정확한 매핑)
export const getBuildingName = (buildingKey: string, regionKey?: string): string => {
    // 부산의 평화시장 특별 처리
    if (buildingKey === '평화시장' && regionKey === '부산') {
        return i18n.t('building.busanPeaceMarket');
    }
    const i18nKey = BUILDING_TO_I18N_KEY[buildingKey];
    return i18nKey ? i18n.t(i18nKey) : buildingKey;
};

// 동대문 건물 층 정보
export const DDM_BUILDING_FLOORS: Record<string, string[]> = {
    디오트: ['전체', '지하1층', '지하2층', '1층', '2층', '3층', '4층', '5층'],
    청평화: ['전체', '지하1층', '1층', '2층', '3층', '4층', '5층'],
    누죤: ['전체', '지하1층', '지하2층', '1층', '2층', '3층', '4층', '5층', '6층', '뒷건물'],
    APM: ['전체', '지하1층', '1층', '2층', '3층', '4층', '5층', '6층', '7층'],
    남평화: ['전체', '지하1층', '1층', '2층', '3층'],
    테크노: ['전체', '지하1층', '1층', '2층', '3층', '4층', '5층', '6층', '별관', '외곽'],
    제일평화: ['전체', '지하1층', '1층', '2층', '3층', '4층', '5층'],
    동평화: ['전체', '지하1층', '1층', '2층', '3층', '4층'],
    '퀸즈스퀘어(광희)': ['전체', '지하1층', '1층', '2층', '3층', '4층', '5층', '6층'],
    스튜디오W: ['전체', '지하1층', '1층', '2층', '3층', '4층', '5층', '6층', '외곽'],
    'DWP (동원프라자)': ['전체', '지하1층', '1층', '2층', '3층', '1층 비기닝', '별관', '외곽'],
    벨포스트: ['전체', '지하1층', '1층', '2층', '3층'],
    'APM 럭스': ['전체', '지하1층', '지하2층', '1층', '2층', '3층', '4층', '5층', '6층'],
    디자이너클럽: ['전체', '지하1층', '지하2층', '1층', '2층', '3층', '4층', '5층', '별관1층', '별관2층'],
    'DDP(유어스)': ['전체', '1층', '2층', '3층'],
    팀204: ['전체', '지하1층', '1층', '2층', '3층', '4층', '5층', '6층'],
    '혜양 엘리시움': ['전체', '지하1층', '1층', '2층', '3층', '4층'],
    'APM PLACE': ['전체', '지하1층', '지하2층', '1층', '2층', '3층', '4층', '5층', '6층', '7층', '8층', '10층'],
    맥스타일: ['전체', '지하1층', '1층', '2층', '3층', '4층', '5층', '6층', '외곽'],
    '신발상가 A동': ['전체', '1층', '2층', '3층', '뒷건물'],
    '신발상가 B동': ['전체', '1층', '2층', '3층', '뒷건물'],
    '신발상가 C동': ['전체', '지하1층', '1층', '2층', '3층', '뒷 건물'],
    '신발상가 D동': ['전체', '1층', '2층', '3층', '일신빌딩 1층', '일신빌딩 2층'],
    '신평화 A동': ['전체', '지하1층', '1층', '2층', '3층', '4층'],
    '신평화 B동': ['전체', '1층', '2층', '3층', '4층'],
    '신평화 C동': ['전체', '1층', '2층', '3층', '4층'],
    평화시장: ['전체', '1층', '2층', '3층'],
    '시즌상가 (JABA11)': ['전체', '1층', '2층', '3층', '4층', '5층', '6층', '7층', '8층', '9층', '지하1층'],
    아트프라자: ['전체', '지하1층', '1층', '2층', '3층'],
    'SANG SANG(상상)': ['전체', '지하1층', '1층', '2층', '3층'],
    동문상가: ['전체', '1층', '2층', '3층', '4층'],
    청계상가: ['전체', '1층', '2층', '3층'],
    서평화: ['전체', '지하1층', '1층', '외곽'],
    종합시장: ['전체', '5층', '6층'],
    통일상가: ['전체', 'A-1F', 'B-1F', 'C-1F', 'A-2F', 'B-2F', 'C-2F', 'A-3F', 'B-3F', 'C-3F'],
    동일상가: ['전체'],
    'NYUNYU (골든타운)': ['전체', '1층', '2층', '3층', '4층', '5층', '6층'],
};

// 남대문 건물 층 정보
export const NMD_BUILDING_FLOORS: Record<string, string[]> = {
    포키아동복: ['전체', '1층', '외곽'],
    원아동복: ['전체'],
    부르뎅: ['전체', '1층', '2층', '외곽'],
    마마아동복: ['전체'],
    크레용아동복: ['전체'],
    코코상가: ['전체', '1층', '2층', '3층'],
    '씨티아이 아동복': ['전체', '지하1층', '1층', '2층', '외곽'],
    새로나아동복: ['전체'],
    키즈빌리지: ['전체', '지하1층', '3층', '옆건물'],
    탑랜드아동복: ['전체'],
    페인트타운: ['전체', '지하1층', '1층', '2층', '3층', '4층', '5층', '외곽 2층', '외곽'],
    삼익패션타운: ['전체', '지하1층', '1층', '2층', '3층', '4층', '5층', '6층', '7층', '8층', '9층', '10층'],
    우주상가: ['전체', '지하1층', '1층', '2층', '3층', '4층'],
    '대도 아케이드': ['전체', '지하1층', '1층', '2층'],
    렝땅: ['전체'],
    '원 도깨비': ['전체'],
    '도깨비 C동': ['전체', '지하1층', '1층'],
    '도깨비 D동': ['전체', '지하1층', '1층'],
    '도깨비 E동': ['전체', '지하1층', '1층'],
    유성상가: ['전체'],
    쥬얼파크: ['전체'],
    연세악세사리: ['전체', '1층', '2층'],
    삼호악세사리: ['전체', '1층', '2층', '3층'],
    마노악세사리: ['전체'],
    장안악세사리: ['전체', '1층', '2층'],
    대도쥬얼리: ['전체'],
    자유핸드백: ['전체', '지하1층', '1층', '3층'],
    대도마케트: ['전체'],
    남도상가: ['전체', '2층', '3층'],
    남정상가: ['전체', '지하1층', '1층', '2층', '3층'],
    영창상가: ['전체', '지하1층', '1층', '2층'],
    '대도종합상가 D동': ['전체', '1층', '2층'],
};

// 부산 건물 층 정보
export const BUSAN_BUILDING_FLOORS: Record<string, string[]> = {
    '르네시티(르네관)': ['전체', '1층', '2층', '3층', '4층'],
    '르네시떼(시떼관)': ['전체', '1층', '2층'],
    평화시장: ['전체', '지하1층', '1층', '2층', '3층'],
    남문시장: ['전체', '1층', '2층'],
    자유시장: ['전체', '1층(신발)', '2층(의류)', '4층'],
    진시장: ['전체', '1층', '2층', '3층'],
    '국제시장 3공구 A동': ['전체', '1층', '2층'],
    '국제시장 3공구 B동': ['전체'],
    '국제시장 1공구 B동': ['전체', '지하1층', '1층', '2층'],
    '국제시장 2공구 B동': ['전체'],
    '국제시장 2공구': ['전체'],
    '국제시장 6공구': ['전체'],
};

// 건물 목록
export const BUILDINGS = {
    동대문: [
        '디오트',
        '청평화',
        '누죤',
        'APM',
        '남평화',
        '테크노',
        '제일평화',
        '동평화',
        '퀸즈스퀘어(광희)',
        '스튜디오W',
        'DWP (동원프라자)',
        '벨포스트',
        'APM 럭스',
        '디자이너클럽',
        'DDP(유어스)',
        '팀204',
        '혜양 엘리시움',
        'APM PLACE',
        '맥스타일',
        '신발상가 A동',
        '신발상가 B동',
        '신발상가 C동',
        '신발상가 D동',
        '신평화 A동',
        '신평화 B동',
        '신평화 C동',
        '평화시장',
        '시즌상가 (JABA11)',
        '아트프라자',
        'SANG SANG(상상)',
        '동문상가',
        '청계상가',
        '서평화',
        '종합시장',
        '통일상가',
        '동일상가',
        'NYUNYU (골든타운)',
    ],
    남대문: [
        '포키아동복',
        '원아동복',
        '부르뎅',
        '마마아동복',
        '크레용아동복',
        '코코상가',
        '씨티아이 아동복',
        '새로나아동복',
        '키즈빌리지',
        '탑랜드아동복',
        '페인트타운',
        '삼익패션타운',
        '우주상가',
        '대도 아케이드',
        '렝땅',
        '원 도깨비',
        '도깨비 C동',
        '도깨비 D동',
        '도깨비 E동',
        '유성상가',
        '쥬얼파크',
        '연세악세사리',
        '삼호악세사리',
        '마노악세사리',
        '장안악세사리',
        '대도쥬얼리',
        '자유핸드백',
        '대도마케트',
        '남도상가',
        '남정상가',
        '영창상가',
        '대도종합상가 D동',
    ],
    부산: [
        '르네시티(르네관)',
        '르네시떼(시떼관)',
        '평화시장',
        '남문시장',
        '자유시장',
        '진시장',
        '국제시장 3공구 A동',
        '국제시장 3공구 B동',
        '국제시장 1공구 B동',
        '국제시장 2공구 B동',
        '국제시장 2공구',
        '국제시장 6공구',
    ],
};
